import React from "react";
import { Row, Col } from "react-bootstrap";

import { TextWithLoader } from "components";
import { LineDivider } from "components/layout";
import { isHighRiskValue } from "mappers";
import { ViewResidualsSplitProfilesProps } from "types";

import styles from "./../splitProfile.module.scss";

const SplitProfileInformation = ({
	initialValues,
	loading,
}: ViewResidualsSplitProfilesProps) => {
	const {
		userFriendlyId,
		status,
		isHighRisk,
		profileName,
		scenarioType,
		totalRevenueShare,
		isDefault,
	} = initialValues ?? {};

	return (
		<div data-autotest="viewSplitProfileInformationSection">
			<div>
				<h1 className={`${styles.header} ${"mb-3"}`}>
					Residuals Split Profile Information
				</h1>
				{isDefault && (
					<Row>
						<Col lg={6}>
							<TextWithLoader
								value="Default Split Profile"
								loading={loading}
								isIconCheck
								isHideLabel
							/>
						</Col>
					</Row>
				)}
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Profile ID:"
							value={userFriendlyId}
							loading={loading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Status:"
							value={status?.name}
							loading={loading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Profile Name:"
							value={profileName}
							loading={loading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Is Profile High Risk?"
							value={isHighRiskValue(isHighRisk)}
							loading={loading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Scenario:"
							value={scenarioType?.displayName}
							loading={loading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Total Revenue Share:"
							value={
								totalRevenueShare ? `${totalRevenueShare}%` : ""
							}
							loading={loading}
						/>
					</Col>
				</Row>
				<LineDivider />
			</div>
		</div>
	);
};

export default SplitProfileInformation;
